
/**
 * @module devpanel/utils/amplience
 * @description Amplience-related utility schemas and helpers.
 */

const META_SCHEMA = [
  'BadgesMeta', 'BagMeta', 'CouponMeta', 'CreditCardMeta', 'DataCapturePageMetaData',
  'GamBannerMeta', 'GeoLocationSearchMeta', 'LoyaltyMeta', 'MessageMeta', 'OrderConfirmationMeta',
  'OrderStatusMeta', 'OrderSummaryMeta', 'PaymentMeta', 'PricingMeta', 'ProductCardMeta',
  'ProductListingMeta', 'ProductRailMeta', 'QuestionMeta', 'RailAdaMeta', 'RailMeta',
  'ReviewMeta', 'SearchMeta', 'ShippingMethodMeta', 'SnackBarMeta', 'StoreMeta',
  'StoreServicesMeta', 'SummaryCardsMeta', 'TimeMeta', 'TimerMeta', 'TypeAheadMeta',
  'VariantMeta', 'WebpageMetaData', 'MediaGalleryMeta', 'OrderMeta'
];

const EVENT_SCHEMA = ['ApplicationEvents', 'DataCaptureEvent'];

const COMMON_SCHEMA = [
  'common', 'Action', 'Article', 'Notifications', 'Page', 'DataModel', 'Domain',
  'Scope', 'Attribute', 'DataMappingChannel', 'DataLayerMapping', 'BirthdayNotification',
  'BrandStore', 'AllBrandStores', 'Breadcrumb', 'CacheBuster', 'CheckBoxField',
  'ContextualTag', 'FilterResultsAction', 'FiltersColumn', 'InputField',
  'SiteMapContextConfiguration', 'Sitemap', 'UltaAsset', 'Validation',
  'OverLayContainer', 'SelectField', 'LabelAction', 'SnackBar', 'UserAction',
  'IncrementalModule', 'Spacer'
];

const NAVIGATION_MODULES = ['NavigationLink', 'NavigationLinksSubGroup', 'NavigationLinksGroup', 'PrimaryLink'];

const MODULES_EXCLUDED_FOR_ANCHORS = [
  'Action', 'Button', 'ActionGroup', 'CacheBuster', 'ColumnContainer', 'DataCaptureEvent',
  'DataMappingChannel', 'DataModel', 'Dialog', 'Domain', 'InputField', 'JSscriptTag',
  'Page', 'Robots', 'SelectField', 'Spacer', 'Text', 'VerticalSlot', 'ApplicationEvents'
];

/**
 * A combined array of schema module names and common modules that should be skipped or excluded
 * from anchor tag rendering or standard devpanel processes.
 * @type {string[]}
 */
export const skipCommonModules = [...COMMON_SCHEMA, ...META_SCHEMA, ...EVENT_SCHEMA, ...MODULES_EXCLUDED_FOR_ANCHORS, ...NAVIGATION_MODULES, 'MainWrapper'];

/**
 * Generates an edit link to the Amplience authoring interface for a specific content item.
 *
 * @function buildAmplienceLink
 * @param {string} contentId - The unique Amplience content item ID.
 * @param {Object} [metadata] - Metadata containing environment/hub information.
 * @param {string} [metadata.hub] - The hub suffix identifier (e.g. '-prod' or '-qa').
 * @returns {string} The fully qualified edit URL for the Amplience content item.
 */
export const buildAmplienceLink = ( contentId, metadata ) => {

  const hub = metadata?.hub || '';
  return `https://ulta.app.amplience.net/content/#!/ulta${ hub }/authoring/content-item/edit/${ contentId }`;
};
